import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

function Select({ action, variables, setOpenVariable, variableRender }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATABASE.SELECT.';

    return (
        <div>
            <div className="form-element">
                {t(label + 'QUERY')}
                <TextInput action={action} inputName="query" variables={variables} setOpenVariable={setOpenVariable} multiline isRequired={true} />
            </div>
            <div className="form-element">
                {t(label + 'TIMEOUT')}
                <TextInput action={action} inputName="timeout" variables={variables} setOpenVariable={setOpenVariable} />
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.REPEATABLE.REPEAT.ASSIGN_TO_VARIABLE')}
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    isRequired={false}
                />
            </div>
        </div>
    )
}

export default Select;
